"use client";

import { Button } from "@/components/ui/button";
import { signIn } from "next-auth/react";

const LoginForm = () => {
  // WIP
  const onClickGithub = () => {
    signIn("github");
  };
  const onClickGoogle = () => {
    signIn("google");
  };
  return (
    <div className="space-y-3">
      <Button onClick={onClickGithub} variant="outline" className="w-full">
        Login with GitHub
      </Button>
      <Button onClick={onClickGoogle} variant="outline" className="w-full">
        Login with Google
      </Button>
    </div>
  );
};

export default LoginForm;
